import { render, staticRenderFns } from "./npc-list.vue?vue&type=template&id=6fba2046&scoped=true&"
import script from "./npc-list.vue?vue&type=script&lang=js&"
export * from "./npc-list.vue?vue&type=script&lang=js&"
import style0 from "./npc-list.vue?vue&type=style&index=0&id=6fba2046&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba2046",
  null
  
)

export default component.exports